
export function mayBeErrnoException(val: unknown): val is { errno?: number, code?: string, path?: string, syscall?: string } & Error {
  return val != null && typeof val === 'object' && (val as Error).message != null;
}

export function exceptionCode(ex: unknown): unknown {
  if (ex && typeof ex === 'object') {
    return (ex as any).code;
  }
  return undefined;
}

export function isFileOrDirectoryMissingError(ex: unknown): boolean {
  const code = exceptionCode(ex);

  /*
    ENOTDIR can happen if we have a path like "/aaa/bbb/ccc.mxf" and either
    "/aaa" or "/aaa/bbb" is not a directory anymore (for instance because the
    "/aaa/bbb" folder has been deleted and a file named "bbb" was in "/aaa"). If
    this happens, it means that the file we were looking for no longer exists.
  */
  return code === 'ENOENT' || code === 'ENOTDIR' || `${ex}`.includes('ENOENT');
}


export function isNameTooLongError(ex: unknown): boolean {
  const code = exceptionCode(ex);

  /*
    ENAMETOOLONG can happen when a file path segment is too long like /my/<very........long>/name.mp4
    or when the total length of the path is too long like /my/very/very/<......>/very/very/long/name.mp4
  */
  return code === 'ENAMETOOLONG' || `${ex}`.includes('ENAMETOOLONG');
}
